import * as angular from 'angular';
import FlowStepTagsIconBridge from './FlowStepTagsIconBridge';

angular
  .module('flowingly.components')
  .component('flowStepTagsIcon', FlowStepTagsIconBridge);
